export default __webpack_public_path__ + "static/media/hu_badge_web_generic.89c4c39b.png";